export const UnitTypes = {
  lookupTypeId: 28,
};
